import React from 'react';
import styles from './ChatHeader.module.scss';

const ChatHeader = ({ title, selectedBot }) => {
  return (
    <div className={styles.chatHeader}>
      <div className={styles.left}>
        <div className={styles['bot']}>
          {selectedBot?.src ? (
            <img
              className={styles['bot-image']}
              src={selectedBot?.src}
              alt=''
            />
          ) : (
            <div className={styles['bot-default']}>
              <p>
                {selectedBot?.botName
                  ?.split(' ')
                  .filter(Boolean)
                  .map((word) => word.charAt(0).toUpperCase())
                  .slice(
                    0,
                    selectedBot?.botName?.trim().split(/\s+/).length > 2
                      ? 3
                      : undefined
                  )
                  .join('')}
              </p>
            </div>
          )}
        </div>
        <div className='description'>
          <h2 className={styles.title}>{selectedBot?.botName}</h2>
          {/* <h2 className={styles.subtitle}>{title}</h2> */}
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
